const withProps = options => options ? (options.props || options) : {};

export {withProps};
